import axios from "axios";
import { ImportWorkingStatus, IOperator } from "../../types";

interface IGetTourOperatorImportsParams {
    type: 'JIMPI' | 'TUI',
    start?: number,
    limit?: number,
    filename: string,
    importDateFrom: string | null,
    importDateTo: string | null,
    skipped: boolean | null,
    businessError: boolean | null,
    technicalError: boolean | null,
    tenants: string[],
    dealers: string[]
}

export interface ITourOperatorImport {
    id: string,
    creationDate: string,
    imported: number,
    status: string,
    creationOperator: IOperator,
    workingStatus: ImportWorkingStatus,
    skipped: number,
    errorLogic: number,
    errors: number,
    total: number,
    inputFile: {
        name:string
    }
}

type IGetTourOperatorImportsReturn = ITourOperatorImport[]

export const getTourOperatorImports = async (params: IGetTourOperatorImportsParams): Promise<IGetTourOperatorImportsReturn> => {
    const response = await axios.post('/booking/import/list', params);
    return response.data;
};

export default getTourOperatorImports;
